import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import waitFor from "@insite/client-framework/Common/Utilities/waitFor";
import { getIsWebCrawler } from "@insite/client-framework/Common/WebCrawler";
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import { addToEndOfChain, executeAwaitableHandlerChain, replaceInChain } from "@insite/client-framework/HandlerCreator";
import loadRealTimeInventory from "@insite/client-framework/Store/CommonHandlers/LoadRealTimeInventory";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import loadProducts from "@insite/client-framework/Store/Data/Products/Handlers/LoadProducts";
import { getProductsDataView } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import { chain, GetUnfilteredProducts, LoadRealTimeInventory } from "@insite/client-framework/Store/Pages/ProductList/Handlers/DisplayProducts";
import { dispatchProductImpressions } from "@store/Services/AnalyticsService";
import setImpression from "@store/Store/Data/Analytics/Handlers/SetImpression";
import { getImpression } from "@store/Store/Data/Analytics/ImpressionsSelectors";
import { getCategory } from "@store/Store/Data/Categories/CategoriesSelectors";
import { getIsCategoryPage, getIsSearchPage } from "@store/Store/Pages/ProductList/ProductListSelectors";import StoreApplicationState from "@store/Store/StoreApplicationState";
import qs from "qs";

addToEndOfChain(chain, async props => {
    if (props.result.products) {
        await waitFor(() => !!props.pricingLoaded);

        const state = props.getState();
        const currentPage = getCurrentPage(state);
        const isSearchPage = getIsSearchPage(state);
        const isCategoryPage = getIsCategoryPage(state);
        const category = getCategory(state);
        const currentCurency = state.context.session.currency?.currencyCode;

        const impressions = getImpression(state as StoreApplicationState);
        const currentPath = global?.location?.href || state.data.pages.location.pathname;
        const matchingImpressions = impressions?.filter(impression => {
            return impression.pageUrl === currentPath;
        });

        const impressionAlreadyOccured = !!matchingImpressions?.length;

        if (impressionAlreadyOccured) {
            return;
        }

        let products: ProductContextModel[] | undefined;

        const {
            pages: {
                productList: { productInfosByProductId },
            },
        } = state;

        if (props.result.products && productInfosByProductId) {
            products = props.result.products.map(product => {
                if (product) {
                    const productContext: ProductContextModel = {
                        product,
                        productInfo: productInfosByProductId[product.id] as ProductInfo,
                    };
                    return productContext;
                }
                return undefined;
            }) as ProductContextModel[];
        }

        if (products) {
            dispatchProductImpressions(
                products,
                currentCurency,
                currentPage,
                isCategoryPage,
                isSearchPage,
                category?.shortDescription || "",
            );
            props.dispatch(setImpression({ pageUrl: currentPath, impressions: props.result.products }));
        }
    }
});

replaceInChain(chain, GetUnfilteredProducts, async props => {
    // Poolcorp custom code - Start
    const { queryString } = props.parameter;
    const { previouslyPurchasedProducts } = qs.parse(queryString.startsWith("?") ? queryString.substr(1) : queryString);
    // Poolcorp custom code - End

    const unfilteredApiParameter = { ...props.apiParameter };
    delete unfilteredApiParameter.searchWithin;
    if (!props.result.productFilters.pageBrandId) {
        delete unfilteredApiParameter.brandIds;
    }
    if (!props.result.productFilters.pageProductLineId) {
        delete unfilteredApiParameter.productLineIds;
    }
    delete unfilteredApiParameter.priceFilters;
    delete unfilteredApiParameter.attributeValueIds;
    if (!props.result.productFilters.pageCategoryId) {
        delete unfilteredApiParameter.categoryId;
    }
    unfilteredApiParameter.stockedItemsOnly = undefined;
    // Poolcorp custom code
    unfilteredApiParameter.previouslyPurchasedProducts = previouslyPurchasedProducts === "true";

    props.result.unfilteredApiParameter = unfilteredApiParameter;
    props.result.filteredApiParameter = { ...props.apiParameter };

    const unfilteredProducts = getProductsDataView(props.getState(), unfilteredApiParameter).value;

    if (unfilteredProducts) {
        return;
    }

    await executeAwaitableHandlerChain(loadProducts, unfilteredApiParameter, props);
});

replaceInChain(chain, LoadRealTimeInventory, props => {
    if (
        !props.result.products?.length ||
        (getIsWebCrawler() &&
            !getSettingsCollection(props.getState()).websiteSettings.includeRealTimeInventoryAndPricingForSeo)
    ) {
        return;
    }

    props.dispatch(
        loadRealTimeInventory({
            productIds: props.result.products.map(o => o.id),
            expand: ["warehouses"], // Poolcorp Custom Code
            onSuccess: realTimeInventory => {
                props.dispatch({
                    type: "Pages/ProductList/CompleteLoadRealTimeInventory",
                    realTimeInventory,
                });
            },
            onError: () => {
                props.dispatch({
                    type: "Pages/ProductList/FailedLoadRealTimeInventory",
                });
            },
            onComplete(realTimeInventoryProps) {
                if (realTimeInventoryProps.apiResult) {
                    this.onSuccess?.(realTimeInventoryProps.apiResult);
                } else if (realTimeInventoryProps.error) {
                    this.onError?.(realTimeInventoryProps.error);
                }
            },
        }),
    );
});
